import { INITIAL_TO_PERIOD, PERIOD_DENORMALIZE } from "library/SFG20/constants.mjs"
import { calculatePeriodIntervalHoursFrom } from "library/period-interval-hours-from-task.mjs"

export function optimiseVisits(visits) {
    const allIntervals = visits.map((v) => {
        const task = {
            frequency: {
                interval: +v.label.slice(0, -1),
                period: INITIAL_TO_PERIOD[v.label.split("").at(-1)],
            },
        }
        return {
            ...task,
            time: calculatePeriodIntervalHoursFrom(task, PERIOD_DENORMALIZE),
            label: v.label,
        }
    })
    const maximal = allIntervals.filter((i) => !allIntervals.some(({ time }) => time > i.time && time % i.time === 0))

    return maximal.sortBy("time")
}
